/* eslint-disable max-classes-per-file */

export interface RequestSearchBookingInterface {
  booking_number?: string;
  email?: string;
  pin_code: string;
}

export class SearchBookingDataPresenter {
  search: string;

  constructor(response: any) {
    this.search = response?.search || "";
  }
}
